export default {
  "site.name": "快猫视频",
  "site.slogan": "短视频创作与分享平台",
  "site.description": "快猫视频是一款专注短视频创作、分享与发现的平台，汇聚海量优质内容，支持一键录制、剪辑、发布，助你轻松成为创作达人。",
  "nav.home": "首页",
  "nav.category": "分类",
  "nav.article": "创作者学院",
  "nav.about": "关于我们",
  "nav.download": "下载APP",
  "footer.copyright": "版权所有",
  "footer.about": "关于我们",
  "footer.help": "帮助中心",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.contact": "联系我们",
  "footer.rights": "快猫视频 保留所有权利",
  "breadcrumb.home": "首页",
  "common.loading": "加载中...",
  "common.error": "加载失败",
  "common.retry": "重试",
  "common.viewMore": "查看更多",
  "common.playCount": "次播放",
  "common.likes": "赞",
  "common.comments": "评论",
  "common.share": "分享",
  "common.back": "返回",
  "common.scrollTop": "回到顶部",
};